import { render, staticRenderFns } from "./SelfServiceFlow.vue?vue&type=template&id=83d9a074&scoped=true&"
import script from "./SelfServiceFlow.vue?vue&type=script&lang=js&"
export * from "./SelfServiceFlow.vue?vue&type=script&lang=js&"
import style0 from "./SelfServiceFlow.vue?vue&type=style&index=0&id=83d9a074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d9a074",
  null
  
)

export default component.exports